import JsEncrypt from 'jsencrypt/bin/jsencrypt.min'

function EncryptedData(publicKey, data){
    return new Promise((resolve) => {
        // 新建JSEncrypt对象
        let encryptor = new JsEncrypt;
        // 设置公钥
        encryptor.setPublicKey(publicKey);
        // 加密数据
        let secret = encryptor.encrypt(data);
        resolve(secret);
    });
}
export default EncryptedData